"use client";

import Script from "next/script";
import { useGetWebsiteAnalyticsQuery } from "@/generated/graphql";

interface UmamiScriptProps {
  storeId: string;
}

export default function UmamiScript({ storeId }: UmamiScriptProps) {
  const { data } = useGetWebsiteAnalyticsQuery({
    variables: { storeId: storeId },
  });

  const websiteId = data?.store?.analyticsWebsite?.id;

  if (!websiteId) return null;
  return (
    <Script
      id="umami-inline"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
      (function () {
        var el = document.createElement('script');
        el.setAttribute('src', 'https://analytics.wuilt.com/script.js');
        el.setAttribute('data-website-id', '${websiteId}');
        document.body.appendChild(el);
      })();
    `,
      }}
    />
  );
}
